module.exports = __webpack_public_path__ + "img/case1.76cfa416.png";